<template>
  <!--内容列表-->
    <div id="onLiveList">
      <div class="allSearch">
        <div class="newSearch d_flex">
          <div style="width: auto;white-space: normal">
            <p>
              <input @keyup.enter="getList(1)" class="allInput" placeholder="OpenId" type="text" v-model="postData.OpenId">
            </p>
            <p>
              <allSelect :chooseData="searchCate" :needReturn="'val'" :placeholder="'类型'" :matchValue="'name'" :showValue="'{{name}}'" v-model="postData.Type">
              </allSelect>
            </p>
            
            <p>
              <cander v-model="postData.StartTime"  :className="'allInput'" placeholderName="动作时间起"  class="d_i" style="vertical-align: middle"></cander>
              <abbr class="d_i">-</abbr>
              <cander :minDate="postData.StartTime" v-model="postData.EndTime" :className="'allInput'" placeholderName="动作时间止"  class="d_i" style="vertical-align: middle"></cander>
            </p>
  
            <button @click="getList(1)" class="redButton">搜索</button>
            
            <button @click="exportFile" class="redButton">导出</button>
          </div>
        </div>
      </div>
      <div class="allTablePlace">
        <div>
          <table cellspacing="0" class="allTable" style="width:100%;table-layout: fixed">
            <thead>
            <tr>
              <th style="width:20%">OpenId</th>
              <th style="width:20%">类型</th>
              
              <th style="width:20%">时间</th>
              <th style="width:20%">停留时间(秒)</th>
              <th style="width:20%">动作页面链接</th>
            </tr>
            </thead>
            <tbody>
            <tr :key="index" v-for="(item, index) in myList">
              <td style="width:20%" class="NoWrap" :title="item.openId">{{item.openId}}</td>
              <td style="width:20%" class="NoWrap" :title="item.type">{{ item.type }}</td>
              
              <td style="width:20%" class="NoWrap" :title="item.logTime">{{item.logTime}}</td>
              <td style="width:20%" class="NoWrap">{{item.readTime}}</td>
              <td style="width:20%" class="NoWrap" :title="item.url">{{item.url}}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <page v-if="totalPage !== 0" :totalCount="totalCount" v-on:on-getList="getList($event)" :totalPage="totalPage" :page="page" :explain="0"></page>
      </div>
  
    </div>
  </template>
  
  <script>
   import connom from '../../../assets/js/common'
  export default {
    name: 'onLiveList',
    data () {
      return {
        baseUrl: process.env.config.baseUrl,
        totalPage: 1,
        totalCount: 0,
        page: 1,
        searchCate:[{
          name:'页面返回',
          val:1
        },{
          name:'跳转登陆前',
          val:2
        },{
          name:'跳转登陆后',
          val:3
        },{
          name:'首页访问',
          val:4
        },{
          name:'收藏访问',
          val:5
        }],
        postData: {
          OpenId: '',
          Type: '',
          StartTime: '',
          EndTime:'',
          PageIndex: 1,
          PageSize: this.$commonJs.commonPageSize
          
        },
        myList: [],
      }
    },
    created () {
      this.getList(1)
    },
    methods: {
      getList (pageIndex) {
        this.postData.PageIndex = pageIndex
        let data = JSON.parse(JSON.stringify(this.postData))
        if (!data.StartTime) {
          delete data.StartTime
        }
        if (!data.EndTime) {
          delete data.EndTime
        }

        let url = this.$commonJs.returnQuery('/api/BuryingPoint/queryActionLog', data)
      this.$axiox.getList(url).then(msg => {
            console.log(msg)
            this.myList = msg.data
            this.page = pageIndex
            this.totalPage = Math.ceil(msg.total / this.postData.PageSize)
            this.totalCount = msg.total
      })

      },
      exportFile(){
        var xmlResquest = new XMLHttpRequest()
      if (window.XMLHttpRequest) { // Mozilla 浏览器
        xmlResquest = new XMLHttpRequest()
      } else {
        if (window.ActiveXObject) { // IE 浏览器
          try {
            // eslint-disable-next-line no-undef
            xmlResquest = new ActiveXObject('Microsoft.XMLHTTP')
          } catch (e) {
            // eslint-disable-next-line no-undef
            xmlResquest = new ActiveXObject('Msxml2.XMLHTTP')
          }
        }
      }
      let data = this.postData
      if (!data.StartTime) {
          delete data.StartTime
        }
        if (!data.EndTime) {
          delete data.EndTime
        }
      let url = this.$commonJs.returnQuery(this.baseUrl + '/api/BuryingPoint/exportActionLogList', data)
      xmlResquest.open('GET', url, true)
      xmlResquest.setRequestHeader('Content-type', 'application/json')
      xmlResquest.setRequestHeader('Authorization', 'Bearer ' + window.sessionStorage.getItem('TaToken'))
      xmlResquest.responseType = 'blob'
      xmlResquest.onload = function (oEvent) {
        var contentType = xmlResquest.getResponseHeader('Content-Type');
        if(contentType==='application/json'){
          connom.alertTips({
                type: 'error',
                title: '错误',
                content: '仅可导出最大一个月时间的数据，请调整筛选条件后再尝试',
                stayTime: 5
              })
          return
        }
        var content = xmlResquest.response
        var elink = document.createElement('a')
        elink.download = '行为日志.xlsx'
        elink.style.display = 'none'
        var blob = new Blob([content])
        elink.href = URL.createObjectURL(blob)
        document.body.appendChild(elink)
        elink.click()
        document.body.removeChild(elink)
      }
      xmlResquest.send()
      }
    },
  }
  </script>
  
  <style scoped>
  .forElClass >>> .el-date-editor.el-range-editor{
    width: 100%
  }
  .forElClass >>> .el-date-editor.el-input.el-input--prefix.el-input--suffix.el-date-editor--time {
    width: 148px!important
  }
  .forElClass >>> .el-date-editor.el-range-editor.is-active{
    background-color: #fff;
  }
  .forElClass >>> .el-range-editor.is-active, .forElClass >>> .el-range-editor.is-active:hover {
    border-color: #DEDEDE;
  }
  .fade-enter-active, .fade-leave-active {
      transition: opacity 0.7s
  }
  .fade-enter, .fade-leave-to {
      opacity: 0
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/pages/burialPointRecord/burialPointActionHistory.vue